// @flow
import type { CurrentUser } from 'api/currentUser';
import {
  isLoggedIn,
  isLocationInCountry,
  isSalarySurveyCompleted,
  isNonAdmin
} from 'utils/currentUser';
import {
  notificationIsDismissed,
  NOTIFICATIONS
} from 'utils/localNotifications';

export const promoteSalarySurvey = ({
  allowDismissal,
  currentUser
}: {
  allowDismissal?: boolean,
  currentUser: CurrentUser
}) =>
  (!allowDismissal ||
    !notificationIsDismissed(NOTIFICATIONS.SALARY_SURVEY_CTA)) &&
  isLoggedIn(currentUser) &&
  currentUser.isLoaded &&
  currentUser.locale === 'en' &&
  isLocationInCountry(currentUser, 'US') &&
  !isSalarySurveyCompleted(currentUser) &&
  isNonAdmin(currentUser);
